import { ProgressBarProps } from './progress-bar'

const ProgressBarFilled = ({ progress }: ProgressBarProps) => (
  <div className="text-text-primary bg-text-primary2 border-text-primary/30 relative h-[24px] w-full overflow-hidden rounded-xl border-[0.7px] text-center text-sm font-semibold leading-[22px]">
    <div
      className="text-background-secondary bg-text-primary absolute inset-0 h-full overflow-hidden rounded-xl"
      style={{ width: `${progress}%` }}
    >
      <div style={{ width: `${100 * (100 / progress)}%` }}>{progress}%</div>
    </div>
    {progress}%
  </div>
)

export default ProgressBarFilled
